import { memo } from 'react';
import { type Control, Controller, type UseFormGetValues, type UseFormSetValue } from 'react-hook-form';
import type { ClientRole } from '@/api/roles-and-permission';
import Checkbox from '@/components/UI/Form/Checkbox';
import { isAllChecked, type PrevilegesForm, type TProductGroupType } from '@/features/Settings/RolesAndPermission/utils';
import type { PermissionGroup } from '@/types/Permission';

type CheckboxCellProps = {
  role: ClientRole;
  permissionKey: PermissionGroup;
  slug: string;
  permissionIndex: number;
  control: Control<PrevilegesForm>;
  getValues: UseFormGetValues<PrevilegesForm>;
  setValue: UseFormSetValue<PrevilegesForm>;
  currentNav: TProductGroupType;
};

export const CheckboxCell = memo(
  ({ role, permissionKey, slug, permissionIndex, control, getValues, setValue, currentNav }: CheckboxCellProps) => {
    const name = `${role.slug}.${permissionKey}.${slug}`;

    const updateAllSelectedCheckboxState = (e: React.ChangeEvent<HTMLInputElement>) => {
      const allPermissions = getValues();
      allPermissions[role.slug][permissionKey][slug] = e.target.checked;
      const currentRolePermissions = allPermissions[role.slug];

      const allCheckboxState = {
        ...currentRolePermissions.all,
        [currentNav]: isAllChecked(currentNav, role.slug, allPermissions),
      };

      setValue(`${role.slug}.all`, allCheckboxState, {
        shouldDirty: true,
      });
    };

    return (
      <td key={name} className={`p-2 border-t ${permissionIndex === 0 && 'border-t-0'}`}>
        <div className='flex justify-center'>
          <Controller
            name={`${role.slug}.${permissionKey}.${slug}`}
            control={control}
            render={({ field, fieldState: { error } }) => (
              <>
                <Checkbox
                  inputClassName='-mr-2'
                  onChange={(e) => {
                    field.onChange(e);
                    updateAllSelectedCheckboxState(e);
                  }}
                  checked={field.value}
                  error={error?.message}
                />
              </>
            )}
          />
        </div>
      </td>
    );
  }
);
